export const STATUS_CONFIG = {
  calculado: { tag: "is-success", label: "Calculado" },
  terminada: { tag: "is-link", label: "Terminada" },
  proceso: { tag: "is-dark", label: "En proceso" },
  enviado: { tag: "is-warning", label: "Enviado" },
  creada: { tag: "is-grey", label: "Creada" },
  error: { tag: "is-danger", label: "Error" },
};

export const MAILJET_STATUS_CONFIG = {
  success: {
    tag: "is-success",
    label: "Aceptado",
    tooltip:
      "El servidor destino aceptó el email. La entrega final depende del proveedor del destinatario.",
  },
  sent: {
    tag: "is-success",
    label: "Entregado",
    tooltip:
      "El servidor SMTP destino aceptó el mensaje. No garantiza que llegó a la bandeja.",
  },
  open: {
    tag: "is-link",
    label: "Abierto",
    tooltip: "El destinatario abrió el email.",
  },
  click: {
    tag: "is-info",
    label: "Clic",
    tooltip: "El destinatario hizo clic en al menos un enlace del email.",
  },
  bounce_hard: {
    tag: "is-danger",
    label: "Rebote definitivo",
    tooltip:
      "Dirección inválida o servidor inexistente. Se bloquea automáticamente.",
  },
  bounce_soft: {
    tag: "is-warning",
    label: "Rebote temporal",
    tooltip:
      "Buzón lleno o problema de conexión. Se reintentará el envío; tras 5 días se convierte en definitivo.",
  },
  spam: {
    tag: "is-dark",
    label: "Spam",
    tooltip: "El destinatario marcó el email como spam.",
  },
  blocked: {
    tag: "is-light",
    label: "Bloqueado",
    tooltip:
      "Bloqueado proactivamente por rebotes previos, spam u otras razones para proteger tu reputación.",
  },
};



// WEBPACK FOOTER //
// ./src/components/climan/helpers/constants.js